import { DetalhamentoFaturaClienteConsulta } from './detalhamento-fatura-cliente-consulta';
import { DetalhamentoFaturaClienteLaudo } from './detalhamento-fatura-cliente-laudo';
import { DetalhamentoFaturaClienteDesconto } from './detalhamento-fatura-cliente-desconto';

export class DetalhamentoFaturaCliente {
  id: number;
  idUnidade: number;
  razaoSocial: string;
  nomeFantasia: string;
  documento: string;
  telefone: string;
  email: string;

  periodoFaturamento: string;
  gerarNota: boolean;
  gerarBoleto: boolean;
  mesReferencia: number;
  anoReferencia: number;

  rua: string;
  bairro: string;
  cidade: string;
  estado: string;
  numero: number;
  cep: string;

  listaConsulta: [DetalhamentoFaturaClienteConsulta];
  listaCortesia: [DetalhamentoFaturaClienteConsulta];
  listaLaudo: [DetalhamentoFaturaClienteLaudo];

  listaDesconto: [DetalhamentoFaturaClienteDesconto];

  constructor(detalhamentoFaturaCliente) {
    this.id = detalhamentoFaturaCliente['id'] || null;
    this.idUnidade = detalhamentoFaturaCliente['idUnidade'] || null;
    this.razaoSocial = detalhamentoFaturaCliente['razaoSocial'] || null;
    this.nomeFantasia = detalhamentoFaturaCliente['nomeFantasia'] || null;
    this.documento = detalhamentoFaturaCliente['documento'] || null;
    this.telefone = detalhamentoFaturaCliente['telefone'] || null;
    this.email = detalhamentoFaturaCliente['email'] || null;

    this.gerarNota = detalhamentoFaturaCliente['gerarNota'] || null;
    this.gerarBoleto = detalhamentoFaturaCliente['gerarBoleto'] || null;
    this.mesReferencia = detalhamentoFaturaCliente['mesReferencia'] || null;
    this.anoReferencia = detalhamentoFaturaCliente['anoReferencia'] || null;

    this.rua = detalhamentoFaturaCliente['rua'] || null;
    this.bairro = detalhamentoFaturaCliente['bairro'] || null;
    this.cidade = detalhamentoFaturaCliente['cidade'] || null;
    this.estado = detalhamentoFaturaCliente['estado'] || null;
    this.numero = detalhamentoFaturaCliente['numero'] || null;
    this.cep = detalhamentoFaturaCliente['cep'] || null;

    this.listaConsulta = (detalhamentoFaturaCliente['listaConsulta'] || []).map(f=>new DetalhamentoFaturaClienteConsulta(f));
    this.listaCortesia = (detalhamentoFaturaCliente['listaCortesia'] || []).map(f=>new DetalhamentoFaturaClienteConsulta(f));
    this.listaLaudo = (detalhamentoFaturaCliente['listaLaudo']  || []).map(f=>new DetalhamentoFaturaClienteLaudo(f));
    this.listaDesconto = (detalhamentoFaturaCliente['listaDesconto'] || []).map(f=>new DetalhamentoFaturaClienteDesconto(f));
  }

}
